import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { Selection } from "office-ui-fabric-react/lib/DetailsList";
import { getValidatorTypes } from "../../../connectors/validators/connectors";
import { translateValidatorDescription, translateValidatorName } from "../../validators/actions/translateValidator";
import { useTranslation } from 'react-i18next';

export const useValidatorList = (onSelection?: any, onInvoke?: any) => {
  const { t } = useTranslation("admin");
  const { data } = useQuery("validators", getValidatorTypes)
  const [groups, setGroups] = useState<any>([
    { name: t("validatorTypes.groups.containers"), validatorType: 0 },
    { name: t("validatorTypes.groups.orders"), validatorType: 1 },
    { name: t("validatorTypes.groups.receptionPlaces"), validatorType: 2 }
  ]);
  const [items, setItems] = useState<any>([]);
  const fetchedData = useMemo(() => {
    if (data) {
      return data
    } else return "";
  }, [data]);

  useEffect(() => {
    if (data) {
      generateGroups(data.data.data);
      generateItems(data.data.data);
    }
  }, [JSON.stringify(fetchedData), t]);

  const generateGroups = (items: Array<any>) => {
    const result: any = {};
    const typeNames: any = {
      0: t("validatorTypes.groups.containers"),
      1: t("validatorTypes.groups.orders"),
      2: t("validatorTypes.groups.receptionPlaces")
    };

    items.forEach(obj => {
      if (!result[obj.type]) {
        result[obj.type] = [];
      }
      result[obj.type].push(obj);
    });

    let index = 0;
    const gr = Object.keys(result).map((key: string) => {
      const item = result[key];
      const grItem = {
        name: typeNames[key],
        count: item.length,
        key: key,
        startIndex: index,
      };
      index += item.length;
      return grItem;
    });

    setGroups(gr);
  };

  const generateItems = (items: Array<any>) => {
    const result: any[] = [];
    items.forEach(obj => {
      if (!result[obj.type]) {
        result[obj.type] = [];
      }
      result[obj.type].push(obj);
    });

    const arr: Array<any> = [];
    result.forEach((item: any) => {
      const parsedItems = item.map((item: any) => {
        return {
          ...item,
          validators: `${translateValidatorName(item.name, t)} - ${translateValidatorDescription(item.name, item.description, t)}`
        }
      })

      arr.push(...parsedItems);
    });

    setItems(arr);
  };

  const columns = useMemo(
    () => [
      {
        key: "validators",
        name: t("validatorTypes.columns.validators"),
        fieldName: "validators",
        minWidth: 300,
        maxWidth: 500,
        isResizable: true,
      },
    ],
    [t]
  );

  const selection = useMemo(
    () =>
      new Selection({
        onSelectionChanged: () => {
          if (onSelection) {
            onSelection(selection.getSelection());
          }
        },
      }),
    []
  );

  const handleInvoke = (item: any) => {
    if (onInvoke) {
      onInvoke();
    }
  };

  return {
    groups,
    items,
    columns,
    selection,
    handleInvoke,
  };
};